import Filterizr from 'filterizr'

let filters

export default {
  filter(filterName) {
    filters.filter(filterName)
  },

  initFiltering() {
    const obj = this
    if( $('.js-filter-container').length > 0){
      const grid_options = {
        layout: 'sameWidth',
        delay: 120,
        delayMode: 'alternate',
        easing: 'cubic-bezier(.39,.02,.38,.97)',
        gutterPixels: 20,
        callbacks: {
          onInit: function() {
            forceSameHeight()
            $('.project-results').find('img').removeAttr('loading')
          },
          onFilteringStart: function() {
            forceSameHeight()
          },
        },
        filterOutCss: {
          opacity: 0,
          transform: 'scale(1)',
        },
        filterInCss: {
          opacity: 1
        }
      }

      filters = new Filterizr('.js-filter-container', grid_options)

      if (window.location.hash != '') {
        obj.filter(location.hash.replace('#', ''))
      }
    }
    forceSameHeight()

    function forceSameHeight(){
      var maxHeight = -1

      $('.projects-results .grid__item').each(function() {
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height()
      })

      $('.projects-results .grid__item').each(function() {
        $(this).height(maxHeight)
      })
    }

    return obj
  }
}

$.fn.selectProjectCategory = function() {
  let self = this

  var filter = '#' + $(this).attr('data-filter')
  if (filter == '#all' && (window.location.hash == '' || window.location.hash == '#')) {
    self.addClass('project-categories__link--active')
    $.mlmi.projects.filter('all')
  } else if (window.location.hash == filter) {
    self.addClass('project-categories__link--active')
    $.mlmi.projects.filter(filter)
  }

  self.on('click', function(e) {
    let filter = $(this).attr('data-filter'),
    currentUrl = location.href.split('#')[0],
    hashString = filter == 'all' ? '' : '#' + filter

    /* push history */
    if (e.originalEvent != undefined) {
      $.mlmi.navigation.pushState($.mlmi.navigation.getStateObject({
        filter: filter,
      }, true), document.title, currentUrl + hashString)
    }

    /* link appearance */
    $('.project-categories__link').removeClass('project-categories__link--active')
    self.addClass('project-categories__link--active')
  })

  return function() {
    return self
  }()
}
